export default {
  setProducts(state, products) {
    state.products = products;
  },
  setProduct(state, product) {
    state.product = product;
  },
  setCredit(state, credit) {
    state.credit = credit;
  }
};
